import { render, staticRenderFns } from "./ProductPurchaseCard.vue?vue&type=template&id=b95f104c&scoped=true"
import script from "./ProductPurchaseCard.vue?vue&type=script&lang=js"
export * from "./ProductPurchaseCard.vue?vue&type=script&lang=js"
import style0 from "./ProductPurchaseCard.vue?vue&type=style&index=0&id=b95f104c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b95f104c",
  null
  
)

export default component.exports